'use client';

import React, { useMemo } from 'react';
import Cards from './Cards';
import PrimaryButton from '@/components/ui/Button/PrimaryButton';
import RichText from '@/components/ui/RichText/RichText';
import { PackagesSectionProps } from './types';

export default function PackagesSection({
  data,
  onEnquire = () => {},
  showViewAllButton = true,
  categoryLabel,
  includedLabel,
}: PackagesSectionProps): React.ReactElement {
  const packages = useMemo(() => data?.packages ?? [], [data?.packages]);

  return (
    <section
      id="Packages"
      className="content-wrapper font-regular mx-auto scroll-m-36 px-4 py-8 md:py-10"
    >
      <div className="flex flex-col items-center justify-center text-center">
        {data?.heading?.content && (
          <RichText styles={data.heading.styles}>
            {data.heading.content}
          </RichText>
        )}

        {data?.description?.content && (
          <RichText styles={data.description.styles}>
            {data.description.content}
          </RichText>
        )}
      </div>

      {packages.length > 0 && (
        <div className="mt-6 grid grid-cols-1 items-stretch gap-6 md:grid-cols-1 lg:grid-cols-3">
          {packages.map((pkg) => (
            <div key={pkg.id} className="h-full">
              <Cards
                title={pkg.title}
                testType={pkg.testType}
                price={pkg.price}
                description={pkg.description}
                subDescription={pkg.subDescription}
                gender={pkg.gender}
                referral={pkg.referral}
                notes={pkg.notes}
                hasButton={pkg.hasButton}
                categoryLabel={categoryLabel}
                includedLabel={includedLabel}
                onEnquire={() =>
                  onEnquire({
                    category: 'BoneScan',
                    title: pkg.title,
                    price: pkg.price,
                  })
                }
                defaultOpen={false}
              />
            </div>
          ))}
        </div>
      )}

      {showViewAllButton && (
        <div className="flex justify-center">
          <PrimaryButton
            className="mt-8 md:mt-10"
            data={{
              title: 'View All Health Packages',
              link: '/private-health-packages',
            }}
          />
        </div>
      )}
    </section>
  );
}
